export const WELCOME_ACTION_TYPE = {
  JOIN_TABLE: 1,
  CREATE_TABLE: 2
};

export function absoluteUrl(path) {
  return `${process.env.REACT_APP_BackendURL}${path}`
}
